import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DsPaintingIP, MultiOptDetails_3DS, OptionsConnectedDef, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ds-painting',
  templateUrl: './ds-painting.component.html',
  styleUrls: ['./ds-painting.component.css']
})
export class DsPaintingComponent implements OnInit, OnChanges {
  
    @Input() dsPaintingObj: DsPaintingIP;
    @Input() soLockObtained:boolean;
    @Input() accessLevel: Array<UserType>;
    @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();
    
    disableForm: boolean = false;
    inputDisableMessage: string = 'This form is not yet enabled';
    readonlyAccess : boolean = false;
    Hvr:any = {};
    hasAccessEE: boolean = false;
    hasAccessME: boolean = false;
    hasAccessPM: boolean = false;
    lockFields: boolean = false; // After HOM lock

  
    constructor(public _dataService: DataService, public dialog: MatDialog) { }
  
    ngOnInit(): void {
    }
    ngOnChanges(): void {
       this.disableForm = true;
      if(this.soLockObtained == false){
        this.inputDisableMessage = "You can't Edit";
      }
      else if (this.accessLevel.includes(this._dataService.userType) == false) {
        this.inputDisableMessage = "You don't have EDIT ACCESS.";
      }
      else {
        this.disableForm = false;
        // this.checkUserEnabled();
      }
      if(this._dataService.hasReadOnlyAccess){
        this.readonlyAccess = true;
      }
      this.hasAccessEE = this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessME = this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessPM = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      if (!this.dsPaintingObj.parentSORef.isDatasheetSubOrderEnabled) {
        this.lockFields = false;
      }
      else {
        this.lockFields = true;
      }
  
    }
   
  addNeSeperatorColorBlock() {
    this.dsPaintingObj.addSeperateColorDS(new MultiOptDetails_3DS("", "", ""));
  }
  removeSeperatorColorBlock(_crDS: MultiOptDetails_3DS) {
    if (_crDS) {
      this.dsPaintingObj.removeSeperateColorDS(_crDS);
    }
  }

  isSeperateColorSpecReqApplicable(_scDS: MultiOptDetails_3DS): boolean {
    if (_scDS.type2 == "006") return true; // Applicable when option is Special Req
    else{
      _scDS.type3 = "";
      return false;
    }
  }

    onTypOfPaintProcChange() {
      // Clear paintProcDoc & paintFinish selection when typOfPaintProc changes
      this.dsPaintingObj.paintProcDoc = "";
      this.dsPaintingObj.paintFinish = "";
    }

    filterPPDoc(_id) {
      // Get the selected option from typPaintProc
      let selectedOption = this._dataService.typPaintProc.find((_obj: OptionsConnectedDef) => _obj.optionId == _id);
      
      if (selectedOption && selectedOption.connectedOptionId && selectedOption.connectedOptionId.length > 0) {
        // Filter paintProcDoc by matching connectedOptionId (first connection)
        let connectionId = selectedOption.connectedOptionId[0];
        let _result = this._dataService.paintProcDoc.filter((_obj: OptionsConnectedDef) => {
          return _obj.optionId == connectionId;
        });
        
        // return _result;
        this.dsPaintingObj.paintProcDoc = _result.length > 0 ? _result[0].optionId : "";
        this.filterPFin(this.dsPaintingObj.paintProcDoc);
        return _result;
      }
      
      return [];
    }

    filterPFin(_id) {
      let selectedOption = this._dataService.paintProcDoc.find((_obj: OptionsConnectedDef) => _obj.optionId == _id);
      if (selectedOption && selectedOption.connectedOptionId && selectedOption.connectedOptionId.length > 0) {
        let connectionId = selectedOption.connectedOptionId[0];
        this.dsPaintingObj.paintFinish = connectionId;
      } else {
        this.dsPaintingObj.paintFinish = "";
      }
    }


    
 sectionNoteChangePM(_event: any) {
    this.dsPaintingObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsPaintingObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsPaintingObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection:boolean){
      if(this.updateDatasheet){
        this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, 
            (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data)));
      }
    }
    reloadData(){
      if(this.updateDatasheet){
        this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
      }
    }

  showSoValidation() {
    let _validList: Array<ValidationItem> = [];

    if (this.hasAccessPM) {
      _validList.push(
        new ValidationItem("Multiple Paint Shade Applicable", !!this.dsPaintingObj.paintShadeApplic, " required to save Datasheet."),
        new ValidationItem("Applicable for Front Doors and End Covers", !!this.dsPaintingObj.applicFrntDoorEndCvr, " required to save Datasheet."),
        new ValidationItem("Type of Painting Process", !!this.dsPaintingObj.typOfPaintProc, " required to save Datasheet."),
        new ValidationItem("PM Note", !!this.dsPaintingObj.sectionNotePM, " required to save Datasheet.")
      );
      if (this.dsPaintingObj.isFrntDoorEndCvrSpecReqApplicable) {
        _validList.push(new ValidationItem("Non Standard Shade Details", !!this.dsPaintingObj.applicFrntDoorEndCvrDetail, " required to save Datasheet."));
      }
      for (let i = 0; i < this.dsPaintingObj.seperateColor.length; i++) {
        let sc = this.dsPaintingObj.seperateColor[i];
        _validList.push(
          new ValidationItem("Seperate Color #" + (i + 1), !!sc.type1, " required to save Datasheet."),
          new ValidationItem("Color Type #" + (i + 1), !!sc.type2, " required to save Datasheet.")
        );
      }
    }

    if (this.hasAccessME) {
      _validList.push(
        new ValidationItem("MIMIC", !!this.dsPaintingObj.mimic, " required to save Datasheet."),
        new ValidationItem("MIMIC V2", !!this.dsPaintingObj.mimic_v2, " required to save Datasheet."),
        new ValidationItem("ME Note", !!this.dsPaintingObj.sectionNoteME, " required to save Datasheet.")
      );
    }

    if (this.hasAccessEE) {
      _validList.push(
        new ValidationItem("EE Note", !!this.dsPaintingObj.sectionNoteEE, " required to save Datasheet.")
      );
    }

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, { width: '50%', data: vSummaryObj });
  }

  saveSOValidation(): boolean {
    if (this.hasAccessPM) {
      if (!this.dsPaintingObj.paintShadeApplic || !this.dsPaintingObj.applicFrntDoorEndCvr ||
        !this.dsPaintingObj.typOfPaintProc || !this.dsPaintingObj.sectionNotePM) {
        return false;
      }
      if (this.dsPaintingObj.isFrntDoorEndCvrSpecReqApplicable) {
        if (!this.dsPaintingObj.applicFrntDoorEndCvrDetail) return false;
      }
      for (let sc of this.dsPaintingObj.seperateColor) {
        if (!sc.type1 || !sc.type2) return false;
      }
    }
    if (this.hasAccessME) {
      if (!this.dsPaintingObj.mimic || !this.dsPaintingObj.mimic_v2 || !this.dsPaintingObj.sectionNoteME) {
        return false;
      }
    }
    if (this.hasAccessEE) {
      if (!this.dsPaintingObj.sectionNoteEE) return false;
    }
    return true;
  }

}

